const firstCharIndex = 1;

export const prepareContentTypeImage = (field: string) => {
  const type = field.slice(firstCharIndex);
  return `image/${type}`;
};
